import { ReactNode } from 'react';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { QueryResult, BreadcrumbModel } from './N05Breadcrumb.types';
import { CreateBreadcrumbModel } from './N05Breadcrumb.service';
import { Breadcrumbs } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

interface N05BreadcrumbProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: {
    data?: QueryResult;
  };
}

export const Default = (props?: N05BreadcrumbProps): JSX.Element => {
  const id = props?.params?.RenderingIdentifier;
  const showOnMobile = props?.rendering?.params?.ShowOnMobile;
  const model: BreadcrumbModel = CreateBreadcrumbModel(props?.fields?.data);
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const links = (model?.ancestors?.map((ancestor, idx) => (
    <a key={idx} target="_self" href={ancestor?.url?.path}>
      {ancestor?.navigationTitle?.value || ancestor?.name || ''}
    </a>
  )) || []) as ReactNode[];

  return (
    <Breadcrumbs
      id={id ? id : undefined}
      links={links}
      currentPage={model?.currentPage?.navigationTitle?.value || model?.currentPage?.name || ''}
      showOnMobile={Boolean(showOnMobile)}
      data-elastic-exclude=""
      data-component={marketingRenderingName}
    />
  );
};
